import React, { useState, useContext, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";

import ContextComponent from "../../../../AppContext";
import Utils from "../../../../Utils";
import DataTable from "../../../../controls/table/DataTable";
import SectionBreadcrumbs from "./SectionBreadcrumbs";
import AddIcon from "../../../../../assets/img/add.png";
import EditIcon from "../../../../../assets/img/Edit.png";
import SaveIcon from "../../../../../assets/img/Save.png";
import DeleteIcon from "../../../../../assets/img/Delete.png";
import EmptyPage from "../../../../pages/EmptyPage";

import AddQuestionPage from "./question/AddQuestionPage";
import EditQuestionPage from "./question/EditQuestionPage";


const Section = () => {
  const { siteid, sectionid } = useParams();

  let [showDeleteModal, setShowDeleteModal] = useState(false);
  let [siteName, setSiteName] = useState("");
  let [selectedItemCount, setSelectedItemCount] = useState(0);
  const DISABLED_ICON = Utils.APP_CLASS_NAMES.disableStyle;
  let [editIconClass, setEditIconClass] = useState(DISABLED_ICON);
  let [saveIconClass, setSaveIconClass] = useState(DISABLED_ICON);

  let [tableSelectedItems, setTableSelectedItems] = useState([]);
  let [questionIdForEdit, setQuestionIdForEdit] = useState("");
  let [allQuestions, setAllQuestions] = useState([]);
  let navigate = useNavigate();
  let projectPath = useParams();
  let projectid = projectPath["projectid"];
  const location = useLocation();
  const currPath = location.pathname;

  const isQuiz = Utils.getQuizSurveyMapValue(siteid);

  useEffect(() => {
    if (tableSelectedItems.length === 1) {
      setEditIconClass("");
      setQuestionIdForEdit(tableSelectedItems[0]);
    } else {
      setEditIconClass(DISABLED_ICON);
      setQuestionIdForEdit("");
    }
  }, [tableSelectedItems]);

  let [editModalCanOpen, setEditModalCanOpen] = useState(false);
  let [editableQuestion, setEditableQuestion] = useState({});
  let [editableQuestionIndex, setEditableQuestionIndex] = useState(-1);

  const openEditModal = (e) => {
    e.preventDefault();
    setEditModalCanOpen(true);
    let targetQuestion = {};
    allQuestions.forEach((ques, index) => {
      if (ques.id === questionIdForEdit) {
        targetQuestion = ques;
        setEditableQuestionIndex(index);
      }
    });
    //console.log(targetUser);
    !Utils.isObjectEmpty(targetQuestion) && setEditableQuestion(targetQuestion);
  };

  let { setCanRedirectToLogin, setLoadingState, setAlert } =
    useContext(ContextComponent);

  let [tableColumns, setTableColumns] = useState([
    "id",
    "select",
    "question",
    "questionType",
    "subsection",
    // "answerOptions",
    "questionOrder",
  ]);
  let [tableColumnSchema, setTableColumnSchema] = useState({
    id: {
      type: "hidden",
      title: "id",
    },
    select: {
      type: "checkbox",
      title: "-",
      center: true,
    },
    question: {
      type: "text",
      search: false,
      sort: false,
      title: "Question",
    },
    questionType: {
      type: "text",
      search: false,
      sort: false,
      title: "Type",
    },
    subsection: {
      type: "text",
      search: false,
      sort: false,
      title: "Subsection",
    },
    // answerOptions: {
    //   type: "multiple",
    //   search: false,
    //   sort: false,
    //   title: "Options",
    // },
    questionOrder: {
      type: "order",
      search: false,
      sort: true,
      title: "Order",
      key: "questionOrder",
    },
  });

  let [tableData, setTableData] = useState([]);
  let [canRender, setCanRender] = useState(false);
  let [renderDataTable, setRenderDataTable] = useState(false);
  let [renderEmptyPage, setRenderEmptyPage] = useState(false);
  let [updateTable, setUpdateTable] = useState(false);

  let [orderChanged, setOrderChanged] = useState({});

  const updateTableData = (data) => {
    setAllQuestions(data);
    let questionInfo = data;
    let questionsArray = [];
    if (!Utils.isObjectEmpty(questionInfo)) {
      questionsArray = questionInfo.map((questionData, index) => {
        let questionTableObj = [];
        let questionTableData = [];
        tableColumns.forEach((col) => {
          if (col === "select") {
            questionTableData.push(false);
          } else {
            questionTableData.push(questionInfo[index][col]);
          }
        });
        questionTableObj = questionTableData;
        return questionTableObj;
      });
      let name = data[0]?.site ?? '';
      name.length > 0 && setSiteName("(" + name + ")");
      setTableData(questionsArray);
      setCanRender(true);
    }
  };

  const success = (res) => {
    setLoadingState({
      applyMask: false,
    });
    updateTableData(res.data);

    setRenderDataTable(res.data.length !== 0);
    setRenderEmptyPage(res.data.length === 0);
  };

  const fail = (err) => {
    setLoadingState({
      applyMask: false,
    });
    err?.message?.length && console.log(err);
    if (err?.redirect) {
      setCanRedirectToLogin(true);
    }
  };

  const loadFreshQuestions = () => {
    Utils.getAllQuestions({ siteId: siteid, sectionId: sectionid }).then(success, fail);
  };

  useEffect(() => {
    setLoadingState({
      applyMask: true,
      text: "Loading questions",
    });
    loadFreshQuestions();
  }, []);

  useEffect(() => {
    if (tableData.length) {
      // console.log("table has data now");
    }
  }, [tableData]);

  const handleShow = async (e) => {
    if (tableSelectedItems?.length > 0) {
      await setSelectedItemCount(tableSelectedItems?.length);
      setShowDeleteModal(true);
    }
  };

  const handleClose = async (e) => {
    await setSelectedItemCount(tableSelectedItems?.length);
    setShowDeleteModal(false);
  };

  const deleteSuccess = (res) => {
    setAlert({
      show: true,
      message: "Question(s) deleted successfully",
    });
    setTableSelectedItems([]);
    setUpdateTable(!updateTable);
  };

  const deleteFail = (err) => {
    err?.message?.length && console.log(err);
    // setErrorMessage(error);
    if (err?.redirect) {
      setCanRedirectToLogin(true);
    }
    setAlert({
      show: true,
      message: "Question(s) delete failed",
      type: "danger"
    });
  };

  const handleDelete = async (e) => {
    setShowDeleteModal(false);
    // setLoadingState({
    //   applyMask: true,
    //   text: "Deleting selected " + tableSelectedItems.length + " items",
    // });
    // Refactored to ensure that order is reset after deletion
    let tempTableData = tableData
      .filter((d) => tableSelectedItems.indexOf(d[0]) === -1)
      .map((row, i) => {
        let orderIndex = tableColumns.indexOf("order");
        row[orderIndex] = i + 1; // reset order starting from 1
        return row;
      });
    setTableData(tempTableData);
    // console.log(tempTableData);
    Utils.deleteQuestions(tableSelectedItems).then(deleteSuccess, deleteFail);
  };

  let [addModalCanOpen, setAddModalCanOpen] = useState(false);

  const openAddModal = (e) => {
    e.preventDefault();
    setAddModalCanOpen(true);
  };


  const navgiatToAddPage = (e) => {
    e.preventDefault();
    // console.log("add question here...");
  };

  const navgiatToEditPage = (e) => {
    e.preventDefault();
    allQuestions.forEach((question, index) => {
      if (question.id === questionIdForEdit) {
        // console.log(" edit question: " + section.id);
      }
    });
  };

  useEffect(() => { }, [editableQuestion]);

  const closeAddModal = (e) => {
    setAddModalCanOpen(false);
  };

  const closeEditModal = (e) => {
    setEditModalCanOpen(false);
  };



  useEffect(() => {
    if (Object.keys(orderChanged).length > 0) {
      let action = orderChanged.action;
      // let currentIdx = (parseInt(orderChanged.current, 10)) - 1;
      let currentIdx = parseInt(orderChanged.current, 10); // changed to rowIndex so zero-based
      let targetIdx = action === "plus" ? currentIdx + 1 : currentIdx - 1;

      setOrderChanged({});

      let orderIndex = tableColumns.indexOf("order");

      // deep clone the table data
      let currentTableDataTemp = JSON.parse(JSON.stringify(tableData));

      // swap rows
      let temp = currentTableDataTemp[currentIdx];
      currentTableDataTemp[currentIdx] = currentTableDataTemp[targetIdx];
      currentTableDataTemp[targetIdx] = temp;

      // update the order property
      currentTableDataTemp.forEach((row, i) => {
        row[orderIndex] = i + 1; // order starts from 1
      });

      setTableData(currentTableDataTemp);
      setSaveIconClass("");
    }

  }, [orderChanged]);

  const handleSaveOrder = (e) => {
    // console.log("in handleSaveOrder...");
    // console.log(tableData);

    setLoadingState({
      applyMask: true,
      text: "Saving order",
    });

    const saveOrderSuccess = (res) => {
      setLoadingState({
        applyMask: false,
      });
      setAlert({
        show: true,
        message: res?.data?.message
          ? res.data.message
          : "Order saved successfully!",
        type: "success",
      });

    };

    const saveOrderFail = (err) => {
      setLoadingState({
        applyMask: false,
      });
      err?.message?.length && console.log(err);
      if (err?.redirect) {
        setCanRedirectToLogin(true);
      }
      setAlert({
        show: true,
        message: err?.data?.message
          ? err.data.message
          : "Order save failed",
        type: "error",
      });
    };

    let orderObj = [];
    tableData.forEach((item) => {
      orderObj.push(item[0]);
    });

    Utils.saveOrderForSection({ sectionId: sectionid, orderObj }).then(saveOrderSuccess, saveOrderFail);

  }

  return (
    <div className="indi-body-cards-wrapper d-flex w-100">
      {/* <div className="indi-add-card-title-breadcrumb">
        <SectionBreadcrumbs props={{siteid, sectionid}} />
      </div> */}
      <div className="indi-add-card-title">
        <span>
          <SectionBreadcrumbs props={{ siteid, sectionid, projectid, currPath }} />
        </span>
        <div className="d-none1 w-50 indi-body-actions">
          <div
            className="indi-body-action"
            role="button"
            onClick={openAddModal}
          >
            <img className="indi-w-20" src={AddIcon} alt="Edit-icon"></img>
            Add
          </div>
          <div
            className={`indi-body-action ${editIconClass}`}
            role="button"
            onClick={openEditModal}
          >
            <img className="indi-w-20" src={EditIcon} alt="edit-icon"></img>
            Edit
          </div>
          <div
            className={`indi-body-action ${saveIconClass}`}
            role="button"
            onClick={handleSaveOrder}
          >
            <img className="indi-w-20" src={SaveIcon} alt="save-icon"></img>
            Save
          </div>

          <div className="indi-body-action" role="button" onClick={handleShow}>
            <img className="indi-w-20" src={DeleteIcon} alt="Delete-icon"></img>
            Delete
          </div>
        </div>
      </div>
      {canRender && (
        <>
          {renderDataTable && (
            <DataTable
              minRows={0}
              tableProps={{
                tableColumns,
                tableColumnSchema,
                tableData,
                tableSelectedItems,
                setTableSelectedItems,
                setOrderChanged,
              }}
            />
          )}
          {!renderDataTable && (
            <EmptyPage
              props={{
                emptyMessage: "No questions are available",
              }}
            />
          )}
        </>
      )}

      <Modal centered show={showDeleteModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Delete confirmation?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure to delete select {selectedItemCount} item(s)?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            No
          </Button>
          <Button variant="primary" onClick={handleDelete}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>

      {addModalCanOpen && (
        <AddQuestionPage
          props={{
            addModalCanOpen,
            setAddModalCanOpen,
            tableData,
            setTableData,
            loadFreshQuestions,
            sectionid,
            siteid,
            isQuiz,
          }}
        />
      )}

      {editModalCanOpen && (
        <EditQuestionPage
          props={{
            editModalCanOpen,
            setEditModalCanOpen,
            tableData,
            setTableData,
            editableQuestion,
            editableQuestionIndex,
            loadFreshQuestions,
            sectionid,
            siteid,
            isQuiz,
          }}
        />
      )}
    </div>
  );
};

export default Section;